import { render, staticRenderFns } from "./ZaloraProductForm.vue?vue&type=template&id=9174d5f0&"
import script from "./ZaloraProductForm.vue?vue&type=script&lang=js&"
export * from "./ZaloraProductForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports